export const CallTags = () => {
  return (
    <div className="mt-4 flex flex-col items-center justify-center space-y-2 text-sm text-muted-foreground">
      <div className="space-x-4">
        <span>Discovery Call</span>
        <span>
          {new Date().toLocaleDateString()}{" "}
          {new Date().toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      </div>
    </div>
  );
};
